import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { cn } from "../utils";
import { faCircleUser } from "@fortawesome/pro-regular-svg-icons";

type UserEditTriggerProps = {
    firstName?: string;
    lastName?: string;
    onClick: () => void;
    className?: string;
    /** ENG-19039 — gravitas arm: filled pill (background-tertiary) that turns teal on hover, with the label held at 14px. */
    showOwnerCtaGravitas?: boolean;
};

export function UserEditTrigger({ firstName, lastName, onClick, className, showOwnerCtaGravitas = false }: UserEditTriggerProps) {
    const trimmedFirst = firstName?.trim();
    const lastInitial = lastName?.trim()?.charAt(0).toUpperCase();

    let label: string | undefined;
    if (trimmedFirst && lastInitial) {
        label = `${trimmedFirst} ${lastInitial}.`;
    } else if (trimmedFirst) {
        label = trimmedFirst;
    }

    return (
        <button
            type="button"
            onClick={onClick}
            data-testid="user-edit-trigger"
            data-gravitas={showOwnerCtaGravitas ? "true" : "false"}
            className={cn(
                "group inline-flex items-center gap-2 whitespace-nowrap rounded-full px-3 py-2 text-sm font-semibold text-content-primary hover:bg-background-tertiary focus:outline-none focus-visible:ring-2 focus-visible:ring-content-primary",
                // Gravitas arm: the pill carries the fill at rest instead of only on hover, so hover has to move
                // somewhere else — teal, with every child flipped to its invert token (the name inherits this colour).
                showOwnerCtaGravitas && "bg-background-tertiary px-4 hover:bg-background-brand-b-primary hover:text-content-primary-invert",
                className
            )}
        >
            <div className="flex flex-row items-center gap-2">
                <FontAwesomeIcon icon={faCircleUser} className={cn("size-5 text-content-brand-b", showOwnerCtaGravitas && "group-hover:text-content-primary-invert")} />
                <div className="flex flex-row items-start gap-2 text-sm">
                    {label && <span className="max-w-[157px] truncate font-bold sm:max-w-[55px] md:max-w-[125px]">{label}</span>}
                    <span
                        className={cn(
                            "text-sm font-medium text-content-primary underline sm:text-xs",
                            showOwnerCtaGravitas && "group-hover:text-content-primary-invert sm:text-sm"
                        )}
                    >
                        Edit my info
                    </span>
                </div>
            </div>
        </button>
    );
}

export default UserEditTrigger;
